export * from './detail-layout.component';
export * from './detail-layout.module';
